/**
 * Checks if there are any badges to render based on the provided props
 * @param {Object} props - Product badge properties
 * @returns {boolean} - Returns true if any badge should be shown
 */
export default function hasABadgeToShowUtil ({
  isTrending,
  isViralOnTikTok,
  discountPercentage,
  isOnlyAtAirshopDiscount,
  wasJustDropped,
  isMini,
  hasSampleBadge,
  hasFullSizeBadge,
  hasStockingStufferBadge,
  shouldAddFullSizeBadge,
  isSetWithAllFullSize,
  isSetWithFullSizeAndMinis,
  isSetWithMinis,
  isTopGiftSet,
  isEquinoxLoves,
  isAllures2024TopPicks,
  isBlackOwned,
  isTopDeal,
  isGiftSet
}) {
  return !!(
    isTrending ||
      isViralOnTikTok ||
      discountPercentage ||
      isOnlyAtAirshopDiscount ||
      wasJustDropped ||
      isMini ||
      hasSampleBadge ||
      hasFullSizeBadge ||
      hasStockingStufferBadge ||
      shouldAddFullSizeBadge ||
      isSetWithAllFullSize ||
      isSetWithFullSizeAndMinis ||
      isSetWithMinis ||
      isTopGiftSet ||
      isEquinoxLoves ||
      isAllures2024TopPicks ||
      isBlackOwned ||
      isTopDeal ||
      isGiftSet
  )
}
